import { Component, OnInit, input, signal } from '@angular/core';
import { Rl1Box } from '@app/models/payroll/rl1-box.model';
import { Rl1 } from '@app/models/payroll/rl1.model';
import { RL1Service } from '@app/modules/payroll/services';
import { BaseForm } from '@forms/base.form';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-rl1-form',
    templateUrl: './rl1.template.html',
    styles: [
        `
            :host {
                --form-field-appearance-standard-padding-top: 0.25rem;
            }

            label {
                color: var(--grey-800);
            }
        `,
    ],
})
export class RL1Form extends BaseForm implements OnInit {
    rl1 = input.required<Rl1>();
    box45?: string;
    rl1Boxes = signal<{ title?: string; boxes: Rl1Box[] }[]>([]);

    isLoading = true;

    constructor(private rl1Service: RL1Service) {
        super();
    }

    ngOnInit(): void {
        this.rl1Service
            .getBoxes(this.rl1())
            .pipe(tap(() => (this.isLoading = false)))
            .subscribe(this.rl1Boxes.set);
    }
}
